import { gql } from "@apollo/client";

export const GET_FORMA_LIQUIDACION_PROFESIONAL = gql`
  query getFormaLiquidacionProfesional($idTipoProfesional: Int!) {
    formaLiquidacionProfesional(idTipoProfesional: $idTipoProfesional) {
      idFormaLiquidacion
      descripcion
    }
  }
`;